import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DummyWrap from './DummyWrap'


export default function DialogChain(props){
  const [counter, setCounter] = useState(0);
  const titles = props.titles;
  const helpDialogs = props.dialogs;
  const size = helpDialogs.length;

  const _handleBack = () => {
    if(counter === 0){
      props.handleClose();
    }
    else{
      setCounter(counter - 1);
    }
  }

  const _handleNext = () => {
    if(counter + 1 === size){
      props.handleClose();
    }
    else{
      setCounter(counter + 1);
    }
  }

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      >
      <span className="pl-3 pt-3"> {`${counter + 1}/${size}`} </span>
      {
        helpDialogs.map((dialog, i) => {
            return(
              <div>
                {counter === i &&
                  <span>
                    <DialogTitle id="alert-dialog-title">{titles[i]}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        <DummyWrap component={dialog}/>
                      </DialogContentText>
                    </DialogContent>
                  </span>
                }
              </div>
            )
        })
      }
      <DialogActions>
        <Button onClick={_handleBack} color="primary">
          { counter === 0 ? "Back": titles[counter - 1]}
        </Button>
        <Button onClick={_handleNext} color="primary" autoFocus>
          { counter + 1 === size ? "Finish":titles[counter + 1]}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
